import React, { useMemo } from 'react'
import styles from './styles/profile-header.module.scss'
import { Player } from 'types/global'
import InfoBoxContainer from 'components/generic/InfoBoxContainer'
import { calculateCompletion } from 'utils'
import { MY_ACCOUNT_FULL_URL } from 'constants/global'
import LinearProgress from '@material-ui/core/LinearProgress'
import { Box } from '@material-ui/core'
import BtnPrimary from 'components/generic/BtnPrimary'
import { getShouldHideProfileStrength } from 'utils/local-storage'
import { ReactComponent as CloseIcon } from 'images/icons/icn_close.svg'

import { useTranslation } from 'react-i18next'
import { useIsProfileStrengthHidden } from 'components/account/hooks/useIsProfileStrengthHidden'

interface ProfileStrengthProps {
  profile: Player
}

const ProfileStrength: React.FC<ProfileStrengthProps> = ({ profile }) => {
  const { t } = useTranslation('strMyAccount')
  const completionPercentage = useMemo(() => calculateCompletion(profile), [profile])

  const { isProfileStrengthHidden, hideProfileStrength } = useIsProfileStrengthHidden(
    profile?.tennisID
  )

  if (
    (profile?.tennisID && getShouldHideProfileStrength(profile.tennisID)) ||
    isProfileStrengthHidden
  )
    return null

  return (
    <InfoBoxContainer>
      <div>
        <button onClick={hideProfileStrength} className={styles.closeBtn} aria-label='close modal'>
          <CloseIcon aria-hidden />
        </button>
      </div>

      <div>
        <h2>{t('profileStrength')}</h2>
        <div className={styles.additionalInfoWrapper}>
          <div className={styles.additionalInfoContainer}>
            <div>{`${completionPercentage}% ${t('completed')}`}</div>

            <Box width='100%'>
              <LinearProgress
                variant='determinate'
                value={completionPercentage}
                classes={{
                  barColorPrimary: styles.progressBarColor,
                  colorPrimary: styles.progressBarSecondaryColor,
                  bar: styles.progressBar,
                }}
                className={styles.linearProgress}
              />
            </Box>
          </div>

          {completionPercentage < 100 && (
            <div className={styles.btnContainer}>
              <BtnPrimary
                className={styles.completeProfileBtn}
                size='medium'
                href={MY_ACCOUNT_FULL_URL}
              >
                {t('completeProfile')}
              </BtnPrimary>
            </div>
          )}
        </div>
      </div>
    </InfoBoxContainer>
  )
}

export default ProfileStrength
